import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import rootSaga from './sagas'
import alerts from './slices/alerts'
import auth from './slices/auth'
import database from './slices/database'
import databasePage from './slices/databasePage'
import editSchedulePage from './slices/editSchedulePage'
import exportReducer from './slices/export'
import history from './slices/history'
import historyPage from './slices/historyPage'
import references from './slices/references'
import schedule from './slices/schedule'
import schedulePage from './slices/schedulePage'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
    reducer: {
        auth,
        schedule,
        schedulePage,
        editSchedulePage,
        references,
        export: exportReducer,
        alerts,
        database,
        databasePage,
        history,
        historyPage,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).prepend(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
})

sagaMiddleware.run(rootSaga)
